/* Бегунок сегментированного контрола (SteosUI.segInd): .ind под выбранной кнопкой, ширина и translateX.
   Первая расстановка — без перехода (бегунок не въезжает с нуля), дальше переход из стилей набора (.seg.anim .ind).
   Ширина бегунка анимируется — исключение APP-SPEC §1.3.3. */
export function segInd(seg: HTMLElement | null): void {
  if (!seg || !seg.offsetWidth) return;
  const on = seg.querySelector<HTMLElement>('button.on');
  if (!on) return;
  let ind = seg.querySelector<HTMLElement>(':scope > .ind');
  const fresh = !ind || !ind.style.width;
  if (!ind) {
    ind = document.createElement('span');
    ind.className = 'ind';
    seg.prepend(ind);
  }
  if (fresh) ind.style.transition = 'none';
  seg.classList.add('anim');
  ind.style.width = on.offsetWidth + 'px';
  ind.style.transform = 'translateX(' + on.offsetLeft + 'px)';
  if (fresh) {
    void ind.offsetWidth;
    ind.style.transition = '';
  }
}
